export default "__VITE_ASSET__BMW0fduz__"